/**
 * Travel Carbon Estimator
 * Copyright (C) 2026  Manuel Leduc
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { name: 'main', path: '/', component: () => import('@/views/HomeView.vue') },
    {
      name: 'project',
      path: '/project/:projectId',
      component: () => import('@/views/ProjectView.vue'),
    },
    {
      name: 'project-travelers',
      path: '/project/:projectId/travelers',
      component: () => import('@/views/TravelersView.vue'),
    },
    {
      name: 'project-locations',
      path: '/project/:projectId/locations',
      component: () => import('@/views/LocationsView.vue'),
    },
    {
      name: 'project-groups',
      path: '/project/:projectId/groups',
      component: () => import('@/views/GroupsView.vue'),
    },
    {
      name: 'project-group-manage',
      path: '/project/:projectId/groups/:groupId',
      component: () => import('@/views/GroupEdit.vue'),
    },
    {
      name: 'sign-in',
      path: '/sign-in',
      component: () => import('@/views/SignIn.vue'),
    },
    {
      name: 'auth-callback',
      path: '/auth/callback',
      component: () => import('@/views/AuthCallback.vue'),
    },
  ],
})

export default router
